import { ApplicationConfig, ErrorHandler } from '@angular/core';
import * as SentryBrowser from '@sentry/browser';
import { ErrorLogger } from '@app/error-logger';

export const browserConfig: ApplicationConfig = {
    providers: [
        { provide: ErrorHandler, useFactory: ErrorLogger.initWith(SentryBrowser) },
    ]
};
